export default __webpack_public_path__ + "static/avatar-fec719e7f1e926fd1f148972ac1a2172.svg";